/* ==========================================================================
   BOS PRODUCT PAGE  ·  assets/bos-product.js
   Variant switching, sticky buy bar, smooth scroll, and a guard against the
   theme's lazy-load minifier blanking the hero product image.
   ========================================================================== */
(function () {
  var root = document.getElementById('bosProduct');
  if (!root) { return; }

  /* ---- the theme's lazy-load script swaps src for a 1x1 placeholder and
     does not always swap it back on a sticky element. The buy card image is
     above the fold, so restore it directly. ---- */
  function unlazy() {
    var img = root.querySelector('.bosp-card-media img');
    if (!img) { return; }
    var real = img.getAttribute('data-src');
    if (real && img.getAttribute('src') !== real) { img.setAttribute('src', real); }
  }
  unlazy();
  window.addEventListener('load', function () {
    unlazy();
    setTimeout(unlazy, 250);
    setTimeout(unlazy, 1000);
  });

  /* ---- variant switching ---- */
  var priceEl   = document.getElementById('bosPrice');
  var compareEl = document.getElementById('bosCompare');
  var addBtn    = document.getElementById('bosAddBtn');
  var stickyBtn = document.getElementById('bosStickyBtn');
  var stickyPr  = document.getElementById('bosStickyPrice');
  var addLabel  = addBtn ? addBtn.textContent.trim() : 'Add to cart';

  function apply(el) {
    if (!el) { return; }
    var price      = el.getAttribute('data-price');
    var compare    = el.getAttribute('data-compare');
    var hasCompare = el.getAttribute('data-has-compare') === '1';
    var available  = el.getAttribute('data-available') === '1';

    if (price && priceEl)  { priceEl.textContent = price; }
    if (price && stickyPr) { stickyPr.textContent = price; }

    if (compareEl) {
      if (hasCompare && compare) {
        compareEl.textContent = compare;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    [addBtn, stickyBtn].forEach(function (b) {
      if (!b) { return; }
      b.disabled = !available;
      b.textContent = available ? addLabel : 'Currently unavailable';
    });
  }

  var radios = root.querySelectorAll('.bosp-variant input[type="radio"]');
  Array.prototype.forEach.call(radios, function (r) {
    r.addEventListener('change', function () { apply(r); });
    if (r.checked) { apply(r); }
  });

  var sel = document.getElementById('bosVariantSelect');
  if (sel) {
    sel.addEventListener('change', function () { apply(sel.options[sel.selectedIndex]); });
    apply(sel.options[sel.selectedIndex]);
  }

  /* ---- sticky buy bar appears once the buy card leaves the viewport ---- */
  var card = document.getElementById('bosCard');
  var bar  = document.getElementById('bosSticky');
  if (card && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          bar.classList.remove('is-on');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('is-on');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { rootMargin: '-140px 0px 0px 0px' }).observe(card);
  }

  /* ---- closing CTA scrolls back to the buy block ---- */
  var jump = root.querySelector('[data-bos-scroll]');
  if (jump) {
    jump.addEventListener('click', function (ev) {
      var target = document.getElementById('bosBuy');
      if (!target) { return; }
      ev.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();
